<template>
  <section class="bg-white h-full relative">
    <div class="search-modal__container" :class="{ 'fixed-container': showSubmitButton }">
      <div v-if="showCloseButton" class="close-btn"><i class="owl-status-error cursor-pointer text-lg" @click="$emit('close')" /></div>
      <div v-if="hasStockData.filterId" class="border border-grey-lighter p-16 mb-8 rounded">
        <h5 class="font-semibold mb-16">{{ hasStockData.groupTitle }}</h5>
        <div class="flex items-center justify-between">
          <span>{{ hasStockData.groupDescription }}</span>
          <label class="owl-switch__wrap" style="transform: scale(0.8);">
            <input type="checkbox" v-model="searchConditions.showInStock">
            <div class="owl-switch__item">
              <div class="owl-switch__bg">
                <div class="owl-switch__button">
                </div>
              </div>
            </div>
          </label>
        </div>
      </div>
      <div v-if="!isEmptyPriceData" class="border border-grey-lighter p-16 mb-8 rounded">
        <h5 class="font-semibold mb-16">{{ $t('searchModal.priceRange') }}</h5>
        <div v-show="!isLoading" class="mb-8">
          <span>{{ currencySign }} {{ Number(priceData.minPrice) | currencyConvert({ inputCurrency: selectedCurrency, listInteger: true }) }}</span> -
          <span>{{ currencySign }} {{ Number(priceData.maxPrice) | currencyConvert({ inputCurrency: selectedCurrency, listInteger: true }) }}</span>
        </div>
        <div class="flex items-center search-modal__price-range">
          <input type="text" :placeholder="$t('searchModal.lowestPrice')" class="input" maxlength="8" v-model="searchConditions.minPrice" @blur="validatePrice" style="border-radius: 20px;" />
          <span class="flex-0 px-8">{{ $t('searchModal.priceTo') }}</span>
          <input type="text" :placeholder="$t('searchModal.highestPrice')" class="input" maxlength="8" v-model="searchConditions.maxPrice" @blur="validatePrice" style="border-radius: 20px;" />
        </div>
      </div>
      <div v-if="tagData && tagData.groupData.length > 0">
        <div class="border border-grey-lighter p-16 rounded">
          <collapse-checkbox-list :title="tagData.groupTitle" :total-amount="tagData.groupData.length">
            <template v-slot:content>
              <div v-for="(tagGroup, index) in tagData.groupData" :key="`tagDroup-${index}-${tagGroup.filterId}`" class="my-4 flex items-center justify-between">
                <div class="text-overflow-ellipsis">
                  <span class="text-sm">{{ tagGroup.text }}</span>
                </div>
                <div class="flex items-center">
                  <span class="text-grey-dark px-8">{{ formatQuantity(tagGroup.count) }}</span>
                  <div class="owl-checkbox-wrap">
                    <label :for="`tagGroup-${tagGroup.filterId}`">
                      <input type="checkbox" :id="`tagGroup-${tagGroup.filterId}`" v-model="searchConditions.filterIds[tagGroup.filterId]">
                      <div class="owl-checkbox" style="margin-right: 0;"></div>
                    </label>
                  </div>
                </div>
              </div>
            </template>
          </collapse-checkbox-list>
        </div>
      </div>
      <div v-if="hotelTypeData.length > 0">
        <div class="border border-grey-lighter mt-8 p-16 rounded">
          <collapse-checkbox-list :title="$t('promotion.form.hotelType')" :total-amount="hotelTypeData.length">
            <template v-slot:content>
              <div v-for="type in hotelTypeData" :key="type.filterId" class="my-4 flex items-center justify-between">
                <div class="text-overflow-ellipsis">
                  <span class="text-sm">{{ type.hotelType }}</span>
                </div>
                <div class="flex items-center">
                  <span class="text-grey-dark px-8">{{ formatQuantity(type.count) }}</span>
                  <div class="owl-checkbox-wrap">
                    <label :for="`hotel-type-${type.filterId}`">
                      <input type="checkbox" :id="`hotel-type-${type.filterId}`" v-model="searchConditions.filterIds[type.filterId]">
                      <div class="owl-checkbox" style="margin-right: 0;"></div>
                    </label>
                  </div>
                </div>
              </div>
            </template>
          </collapse-checkbox-list>
        </div>
        <!-- <h5 class="font-semibold mb-16">{{ $t('promotion.form.hotelType') }}</h5>
        <div v-for="type in hotelTypeData" :key="type.filterId" class="my-4 flex items-center justify-between">
          <div>
            <span class="text-sm">{{ type.hotelType }}</span>
          </div>
          <div class="flex items-center">
            <span class="text-grey-dark px-8">{{ formatQuantity(type.count) }}</span>
            <div class="owl-checkbox-wrap">
              <label :for="`hotel-type-${type.filterId}`">
                <input type="checkbox" :id="`hotel-type-${type.filterId}`" v-model="searchConditions.filterIds[type.filterId]">
                <div class="owl-checkbox" style="margin-right: 0;"></div>
              </label>
            </div>
          </div>
        </div> -->
      </div>
      <div v-if="facilityData.length > 0">
        <div v-for="(facilityGroup, key) in facilityData" :key="key" class="border border-grey-lighter mt-8 p-16 rounded">
          <collapse-checkbox-list :title="facilityGroup.groupName" :total-amount="facilityGroup.groupData.length">
            <template v-slot:content>
              <div
                v-for="facility in facilityGroup.groupData"
                :key="facility.filterId"
                class="my-4 flex items-center justify-between">
                <div class="text-overflow-ellipsis">
                  <img width="16px" :src="facility.iconUrl || defaultFeatureIcon" class="mr-8" />
                  <span class="text-sm">{{ facility.text }}</span>
                </div>
                <div class="flex items-center">
                  <span class="text-grey-dark px-8">{{ formatQuantity(facility.count) }}</span>
                  <div class="owl-checkbox-wrap">
                    <label :for="`facility-${facility.filterId}`">
                      <input type="checkbox" :id="`facility-${facility.filterId}`" v-model="searchConditions.filterIds[facility.filterId]">
                      <div class="owl-checkbox" style="margin-right: 0;"></div>
                    </label>
                  </div>
                </div>
              </div>
            </template>
          </collapse-checkbox-list>
        </div>
      </div>
    </div>
    <div v-if="showSubmitButton" class="search-modal__footer">
      <div>
        <button @click="$emit('close')" class="btn btn-text btn-blue-light">{{ $t('close') }}</button>
      </div>
      <div>
        <button @click="clickClearButton" class="btn btn-ghost btn-grey mr-16">{{ $t('clear') }}</button>
        <button @click="submitHandler" class="btn btn-solid btn-blue-light">{{ $t('filter') }}</button>
      </div>
    </div>
  </section>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'

import collapseCheckboxList from './collapseCheckboxList'

const DEFAULT_FEATURE_ICON = 'https://static.owlting.com/booking/icon/default.svg'

const DEFAULT_SEARCH_CONDITIONS = {
  filterIds: {},
  searchType: {
    hotel: false,
    experience: false
  },
  showInStock: false,
  showQuarantineHotels: false,
  minPrice: undefined,
  maxPrice: undefined
}

const QTY_BOUNDARY = 99

export default {
  props: {
    hotelQuantity: {
      type: Number,
      default: 0
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    tourQuantity: {
      type: Number,
      default: 0
    },
    facilityData: {
      type: Array,
      default: () => {
        return []
      }
    },
    hasStockData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    hotelTypeData: {
      type: Array,
      default: () => {
        return []
      }
    },
    priceData: {
      type: [Object, Array],
      default: () => {
        return []
      }
    },
    quarantineData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    showCloseButton: {
      type: Boolean,
      default: true
    },
    showSubmitButton: {
      type: Boolean,
      default: true
    },
    starData: {
      type: Array,
      default: () => {
        return []
      }
    },
    tagData: {
      type: Object,
      default: () => {}
    },
    syncQuery: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      searchConditions: _.cloneDeep(DEFAULT_SEARCH_CONDITIONS),
      defaultFeatureIcon: DEFAULT_FEATURE_ICON
    }
  },
  components: {
    collapseCheckboxList
  },
  watch: {
    'searchConditions.filterIds': {
      handler (val, oldVal) {
        if (!this.showSubmitButton && (!_.isEmpty(oldVal) || !_.isEmpty(val))) {
          this.$emit('submit', this.searchConditions)
        }
      },
      deep: true
    },
    'searchConditions.searchType': {
      handler () {
        if (!this.showSubmitButton) {
          this.$emit('submit', this.searchConditions)
        }
      },
      deep: true
    },
    'searchConditions.showQuarantineHotels' (val) {
      const isQuarantineHotelId = this.quarantineData?.filterId

      this.searchConditions.filterIds[isQuarantineHotelId] = val
      if (!this.showSubmitButton) {
        this.$emit('submit', this.searchConditions)
      }
    },
    'searchConditions.showInStock' (val) {
      window.dataLayer.push({
        event: `list_available_switch_${val ? 'on' : 'off'}`
      })
      const hasStockId = this.hasStockData?.filterId

      this.searchConditions.filterIds[hasStockId] = val
      if (!this.showSubmitButton) {
        this.$emit('submit', this.searchConditions)
      }
    }
  },
  computed: {
    ...mapGetters({
      isDesktop: 'isDesktop',
      currencySign: 'user/currencySign',
      selectedCurrency: 'user/selectedCurrency'
    }),
    isEmptyPriceData: function () {
      return _.isEmpty(this.priceData)
    }
  },
  methods: {
    clearHandler () {
      this.searchConditions = _.cloneDeep(DEFAULT_SEARCH_CONDITIONS)
    },
    clickClearButton () {
      this.clearHandler()
      this.submitHandler()
    },
    formatQuantity (qty) {
      const isLimitString = typeof qty === 'string' && qty >= QTY_BOUNDARY && qty.indexOf('+') === -1
      const isLimitNumber = typeof qty === 'number' && qty >= QTY_BOUNDARY
      if (isLimitString || isLimitNumber) {
        return `${QTY_BOUNDARY}+`
      }
      return qty
    },
    initialFilterIds () {
      const ids = _.union(this.starData.map(item => item.filterId), this.hotelTypeData.map(item => item.filterId))
      this.facilityData.map(fItem => {
        fItem.groupData.map(gItem => {
          ids.push(gItem.filterId)
        })
      })
      ids.push(this.hasStockData.filterId)
      this.searchConditions.filterIds = _.zipObject(ids, false)
    },
    submitHandler () {
      this.$emit('submit', this.searchConditions)
    },
    validatePrice () {
      const isValid = (price) => {
        if (price && (!Number(price) || price <= 0)) {
          return false
        }
        return true
      }
      if (!isValid(this.searchConditions.minPrice)) {
        this.searchConditions.minPrice = undefined
      } else if (!isValid(this.searchConditions.maxPrice)) {
        this.searchConditions.maxPrice = undefined
      } else {
        if (!this.showSubmitButton) {
          if (this.searchConditions.minPrice && this.searchConditions.maxPrice) {
            if (Number(this.searchConditions.minPrice) <= Number(this.searchConditions.maxPrice)) {
              this.$emit('submit', this.searchConditions)
            }
          } else {
            this.$emit('submit', this.searchConditions)
          }
        }
      }
    }
  },
  mounted () {
    const canFilterSearchType = new Set(['hotel', 'experience'])

    this.initialFilterIds()
    if (this.syncQuery) {
      const query = this.$route.query

      if (query.searchType && canFilterSearchType.has(query.searchType)) {
        this.searchConditions.searchType[query.searchType] = true
      }
      if (query.filter) {
        if (Array.isArray(query.filter)) {
          query.filter.map(item => {
            // this.searchConditions.filterIds[item] = true
            this.$set(this.searchConditions.filterIds, item, true)
          })
        } else if (typeof query.filter === 'string') {
          // this.searchConditions.filterIds[query.filter] = true
          this.$set(this.searchConditions.filterIds, query.filter, true)
        }
      }
      if (this.searchConditions.filterIds[7]) { // 僅顯示可預訂商品 filter-id 為 7
        this.searchConditions.showInStock = true
      }
      if (this.searchConditions.filterIds[8]) { // 僅顯示防疫旅館 filter-id 為 8
        this.searchConditions.showQuarantineHotels = true
      }
      if (query.minPrice) {
        this.searchConditions.minPrice = query.minPrice
      }
      if (query.maxPrice) {
        this.searchConditions.maxPrice = query.maxPrice
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.search-modal
  &__container
    @apply h-auto relative overflow-auto p-8 pin-t pin-x
    &.fixed-container
      @apply absolute
      height: calc(100% - 59px)
    .close-btn
      @apply hidden
      @screen lg
        @apply flex justify-end mb-16 pt-8
  &__footer
    @apply absolute bg-white border-t border-grey-lighter flex justify-between px-16 py-8 pin-b pin-x
  &__price-range
    > input
      width: calc(50% - 8px)
.star
  &:before
    margin: .1em
</style>
